import { Injectable } from '@angular/core';

export enum LocalStorageItemIDs {
  REQUEST_ACCESS_ENABLED_TIME = 'REQUEST_ACCESS_ENABLED_TIME',
  NOISE_CANCELLATION_STATE = 'NOISE_CANCELLATION_STATE',
  MUSIC_MODE_STATE = 'MUSIC_MODE_STATE',
  PDF_UPLOAD_AS_SEPARATE_IMAGES = 'PDF_UPLOAD_AS_SEPARATE_IMAGES',
  DISABLE_ONE_ON_ONE = 'DISABLE_ONE_ON_ONE',
  TOURS_STATE = 'PRODUCT_TOURS_STATE',
  TOOLBOX_APP_USAGE = 'TOOLBOX_APP_USAGE',
  SWITCHER_COLLAPSED_SECTIONS = 'SWITCHER_COLLAPSED_SECTIONS',
}

@Injectable({
  providedIn: 'root',
})
export class LocalStorageService {
  hasItem(itemID: LocalStorageItemIDs, spaceID: string = '', userID: string = ''): boolean {
    return !!this.getItem(itemID, spaceID, userID);
  }

  getItem(itemID: LocalStorageItemIDs, spaceID: string = '', userID: string = ''): string {
    const id: string = this.getID(itemID, spaceID, userID);
    return localStorage.getItem(id) ?? '';
  }

  setItem(itemID: LocalStorageItemIDs, value: string, spaceID: string = '', userID: string = '') {
    const id: string = this.getID(itemID, spaceID, userID);
    localStorage.setItem(id, value);
  }

  removeItem(itemID: LocalStorageItemIDs, spaceID: string = '', userID: string = '') {
    const id: string = this.getID(itemID, spaceID, userID);
    localStorage.removeItem(id);
  }

  clear() {
    localStorage.clear();
  }

  private getID(itemID: LocalStorageItemIDs, spaceID: string = '', userID: string = ''): string {
    const spaceSubStr = spaceID ? `-${spaceID}` : '';
    const userSubStr = userID ? `-${userID}` : '';
    return `${itemID}${spaceSubStr}${userSubStr}`;
  }
}
